import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CepPipe } from './pipes/cep-pipe';
import { FilterPipe } from './pipes/app.filter';
import { FilterPipeAll } from './pipes/app.filterAll';
import { FilterPipePalavrasChave } from './pipes/app.filterPalavrasChave';
import { FilterTablePipe } from './pipes/app.filterTable';
import { FilterFatorPipe } from './pipes/app.filterFator';
import { FilterSortPipe } from './pipes/app.filterSort';
import { FilterCargoPipe } from './pipes/app.filterCargo';
import { FilterSelecionadosPipe } from './pipes/app.filterListagemSelecionados';
import { RemoveExtension } from './pipes/app.removeExtension';
import { NameResume } from './pipes/app.nameResume';
import { LocalDateTimePipe } from './pipes/local-date-time.pipe';
import { LoaderComponent } from './components/loader/loader.component';
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxPaginationModule } from 'ngx-pagination';
import { DataTablesModule } from 'angular-datatables';

import { MDBBootstrapModule, PopoverModule } from 'angular-bootstrap-md';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // <-- Para resolver o ngModel
import { OrderModule } from 'ngx-order-pipe'; // <-- Para resolver o pipe orderBy

import { CargosFiltroComponent } from 'app/modules/cargos/components/cargos-filtro/cargos-filtro.component';
import { CargosSetFatoresComponent } from 'app/modules/cargos/components/cargos-set-fatores/cargos-set-fatores.component';
import { CargosSearchMotivadoresComponent } from 'app/modules/cargos/components/cargos-search-motivadores/cargos-search-motivadores.component';
import { CargosSearchComportamentoComponent } from 'app/modules/cargos/components/cargos-search-comportamento/cargos-search-comportamento.component';
import { CargosSearchAxiologiaComponent } from 'app/modules/cargos/components/cargos-search-axiologia/cargos-search-axiologia.component';
import { FullLoaderComponent } from './components/full-loader/full-loader.component';

@NgModule({
  imports: [
    CommonModule,
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    MDBBootstrapModule.forRoot(),
    NgxPaginationModule,
    PopoverModule,
    DataTablesModule,
    FormsModule,          // 1. Para habilitar o [(ngModel)]
    ReactiveFormsModule,  // Por segurança para uso do formControl
    OrderModule           // 2. Para o pipe 'orderBy' funcionar internamente
   ],
  declarations: [
    CepPipe,
    FilterPipe,
    FilterPipeAll,
    FilterPipePalavrasChave,
    FilterTablePipe,
    FilterFatorPipe,
    FilterSortPipe,
    FilterCargoPipe,
    FilterSelecionadosPipe,
    RemoveExtension,
    NameResume,
    LoaderComponent,
    FullLoaderComponent,
    LocalDateTimePipe,
    
    CargosFiltroComponent,
    CargosSetFatoresComponent,
    CargosSearchMotivadoresComponent,
    CargosSearchComportamentoComponent,
    CargosSearchAxiologiaComponent,
  ],
  exports: [
    CepPipe,
    FilterPipe,
    FilterPipeAll,
    FilterPipePalavrasChave,
    FilterTablePipe,
    FilterFatorPipe,
    FilterSortPipe,
    FilterCargoPipe,
    FilterSelecionadosPipe,
    RemoveExtension,
    NameResume,
    FullLoaderComponent,
    LoaderComponent,
    LocalDateTimePipe,
    BsDatepickerModule,
    DatepickerModule,
    NgxPaginationModule,
    DataTablesModule,

    FormsModule,          // Exportar para que os subcomponentes enxerguem as diretivas
    ReactiveFormsModule,
    OrderModule,          // Exportar o pipe orderBy

    CargosFiltroComponent,
    CargosSetFatoresComponent,
    CargosSearchMotivadoresComponent,
    CargosSearchComportamentoComponent,
    CargosSearchAxiologiaComponent,
   ],
   providers: [
    LocalDateTimePipe
   ]
})
export class SharedModule {}
